<template>
  <div id="404" class="d-flex h-100 align-items-center">

    Denne siden finnes ikke :(

  </div>
</template>

<script>
export default {
  name: '404'
}
</script>
